import { MembershipReceiptPage } from './MembershipReceiptPage';

export const membershipReceiptRouter = {
  '/@/membership/receipt/:payment_statement_id': MembershipReceiptPage,
};
